import { createEventHook } from "@vueuse/core";

export function createVoidEventHook<T>() {
  const hook = createEventHook<T>();

  // override trigger to ignore return values from event hook
  function trigger(payload: T) {
    // @ts-expect-error there's an issue with the typings,
    // https://github.com/vueuse/vueuse/issues/4610
    hook.trigger(payload);
  }

  return {
    on: hook.on,
    off: hook.off,
    trigger,
  };
}

export function createVoidEventHookWithFilter<T>(filter: (payload: T) => boolean) {
  const hook = createEventHook<T>();

  // override trigger to ignore return values from event hook
  function trigger(payload: T) {
    if (filter(payload)) {
      // @ts-expect-error there's an issue with the typings,
      // https://github.com/vueuse/vueuse/issues/4610
      hook.trigger(payload);
    }
  }

  return {
    on: hook.on,
    off: hook.off,
    trigger,
  };
}
